import React from 'react'

const Header = () => {
    return (
        <header className='header'>
            <h1 className='app-title'>Weather App</h1>
        </header>
    )
}

export default Header
